import {createI18n} from 'vue-i18n'
import {getAllTranslations, unpatchTranslationContent} from '@/services/translations.service'
import getLanguageFromDomain from '@/utils/language'

const messages = {
  en: {},
  de: {}
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getLanguageFromDomain(),
  fallbackLocale: 'en',
  messages,
  warnHtmlMessage: false,
  escapeParameterHtml: false,
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

type TFunction = typeof i18n.global.t

// ===== Override t() =====
const originalT: TFunction = i18n.global.t.bind(i18n.global)

i18n.global.t = ((key: string, ...args: unknown[]) => {
  // Decode unicode sequences (\uXXXX)
  const decodedKey = key.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  )

  const params = args as Parameters<TFunction> extends [any, ...infer P] ? P : []

  // Try original key
  let result = originalT(decodedKey, ...params)

  // fallback: strip ®/™ if not found

  if (result === key) {
    const normalizedKey = decodedKey.replace(/\u00ae/g, '').replace(/\u2122/g, '')
    if (normalizedKey !== decodedKey) {
      result = originalT(normalizedKey, ...params)
    }
  }

  result = unpatchTranslationContent(result);

  result = stripQuotes(result);

  return result;
}) as TFunction

function stripQuotes(str: string): string {
  if (typeof str !== 'string') return str;
  if (str.startsWith("'") && str.endsWith("'")) str = str.slice(1, -1);
  if (str.startsWith("''") && str.endsWith("''")) str = str.slice(2, -2);
  return str;
}

// ===== Load messages safely =====
export async function loadLocaleMessages() {
  const messages = await getAllTranslations()
  Object.entries(messages).forEach(([locale, message]) => {
    i18n.global.setLocaleMessage(locale, message)
  })
}

loadLocaleMessages()

export default i18n
